import { actions } from "react-redux-form";
import {
    getVendorDetails,
    getRateCardUploadTypes,
    setRateCardUploadError,
    RateCardUploadModel
} from "../../../constants/model-reducers/external/finance/rate-card-upload.settings";
import { httpDownload, httpPost } from "../../../utils/api.utils";

export const rateCardUploadFormInitialState = RateCardUploadModel;

const defaultState = () => ({
    vendorOptions: [],
    rateCardUploadTypeOptions: [],
    rateCardUploadError: false
});


const initialState = defaultState();

export const RateCardUploadAction = {
    getVendorDetails: () => async (dispatch, state) => {
        var res = await httpPost(`external/ratecardupload/getRateCardUploadVendors`);
        if (res.ok === false) {
            dispatch({
                type: setRateCardUploadError,
                rateCardUploadError: false,
                vendorOptions: []
            })
        } else {
            dispatch({
                type: getVendorDetails,
                data: res
            });
        }
    },

    onVendorSelect: (id) => async(dispatch, state) => {
        const { vendorOptions } = state().rateCardUpload

        dispatch(actions.change("rateCardUploadForm.vendorId", id))
    },

    getRateCardUploadTypes: () => async (dispatch, state) => {
        var res = await httpPost(`external/ratecardupload/getRateCardUploadTypeList`);
        if (res.ok === false) {
            dispatch({
                type: setRateCardUploadError,
                rateCardUploadError: false,
                rateCardUploadTypeOptions: []
            })
        } else {
            dispatch({
                type: getRateCardUploadTypes,
                data: res
            });
        }
    },

    onRateCardTypeSelect: (model, value) => async (dispatch, state) => {
        const intValue = parseInt(value);

        dispatch(actions.change(model, value));
        dispatch(actions.change("rateCardUploadForm.rateCardUploadTypeId", intValue))

    },

    postExecuteProcess: (UploadId) => () => {
        var url = 'external/adminupload/executePackage';

        httpPost(url, UploadId);
    },

    resetRateCardUploadForm: () => async (dispatch, state) => {
        dispatch(actions.reset('rateCardUploadForm.vendorId'));
        dispatch(actions.reset('rateCardUploadForm.rateCardUploadTypeId'));
    },

    downloadRateCardUploadTemplate: (fileAttachmentModule, fileName) => async (dispatch, getState) => {
        const encodedFileName = encodeURIComponent(fileName);
        try {
            const response = await httpDownload(`common/fileAttachment/downloadFile/${fileAttachmentModule}/${encodedFileName}`);
            if (response.ok) {
                response.blob().then(function (blob) {
                    let downloadUrl = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, fileName);
                    } else {
                        a.href = downloadUrl;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }
                });
            } else {
                dispatch({
                    type: setRateCardUploadError,
                    rateCardUploadError: false,
                })
            }
        } catch (error) {
            dispatch({
                type: setRateCardUploadError,
                rateCardUploadError: false,
            })
        }
    }

}

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case getVendorDetails:
            return {
                ...state,
                vendorOptions: action.data
            }
        case getRateCardUploadTypes:
            return {
                ...state,
                rateCardUploadTypeOptions: action.data
            }
        case setRateCardUploadError:
            return {
                ...state,
                rateCardUploadError: action.rateCardUploadError
            }
        default:
            return state
    }
}